// import SectionHome1Team from "../../../sections/home/home1/section-home1-team";
// import SectionHome2Team from "../../../sections/home/home2/section-home2-team";

function OurTeamPage() {
    return (
        <>
            {/* Our Team  */}
            {/* <SectionHome2Team /> */}

            {/* Our Team */}
            {/* <SectionHome1Team /> */}
        </>
    )
}
export default OurTeamPage;